var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73478 3.34837L6.66286 2.42029C6.85435 2.22863 7.08173 2.07656 7.332 1.9728C7.58227 1.86903 7.85054 1.81558 8.12147 1.81552C8.3924 1.81546 8.66069 1.86878 8.91101 1.97243C9.16133 2.07608 9.38878 2.22804 9.58036 2.41961C9.77193 2.61119 9.92389 2.83864 10.0275 3.08896C10.1312 3.33928 10.1845 3.60757 10.1844 3.8785C10.1844 4.14943 10.1309 4.4177 10.0272 4.66797C9.9234 4.91824 9.77134 5.14562 9.57968 5.33711L8.25385 6.66293C8.06233 6.85445 7.83496 7.00638 7.58473 7.11003C7.33449 7.21368 7.06629 7.26703 6.79544 7.26703C6.52459 7.26703 6.25639 7.21368 6.00616 7.11003C5.75592 7.00638 5.52856 6.85445 5.33704 6.66293",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26522 8.65163L5.33714 9.5797C5.14565 9.77137 4.91827 9.92343 4.668 10.0272C4.41773 10.131 4.14946 10.1844 3.87853 10.1845C3.6076 10.1845 3.33931 10.1312 3.08899 10.0276C2.83867 9.92392 2.61122 9.77196 2.41964 9.58038C2.22807 9.38881 2.07611 9.16136 1.97246 8.91104C1.86881 8.66072 1.81549 8.39243 1.81555 8.1215C1.81561 7.85056 1.86906 7.5823 1.97283 7.33203C2.07659 7.08175 2.22866 6.85438 2.42032 6.66289L3.74615 5.33706C3.93767 5.14554 4.16504 4.99362 4.41527 4.88997C4.66551 4.78632 4.9337 4.73297 5.20456 4.73297C5.47541 4.73297 5.74361 4.78632 5.99384 4.88997C6.24407 4.99362 6.47144 5.14554 6.66296 5.33706",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c6aa3f30ffca4c8be52742bde0350186.svg";
export { ForwardRef as ReactComponent };